import { render, staticRenderFns } from "./MyBanner.vue?vue&type=template&id=669a43a1&scoped=true"
import script from "./MyBanner.vue?vue&type=script&lang=js"
export * from "./MyBanner.vue?vue&type=script&lang=js"
import style0 from "./MyBanner.vue?vue&type=style&index=0&id=669a43a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669a43a1",
  null
  
)

export default component.exports